import HttpClienteSeguroParams from '../../Servicios/HttpClienteSeguroParametros';

/**
 * Se encarga de obtener los tipos de ubicaciones del pais.
 * @param {{
 *          companyId:string,
 *          peticionUsuario:{ companyId:string, userId:string, optionId:string, action:string }}} objectRequest
 * @returns {Promise<{data:{
 * Location1Dsc:string,
 * Location2Dsc:string,
 * location3Dsc:string,
 * location4Dsc:string }, status:number}>}
 */
export const obtenerUbicaciones = (objectRequest) => {
    return new Promise((resolve, reject) => {
        HttpClienteSeguroParams.post("/CompaniaUbicaciones/Obtener", objectRequest).then(response => {
            resolve(response);
        })
            .catch(error => {
                resolve(error.response);
            });
    });
};